export default "__VITE_ASSET__DKvvygLK__"